import { noop } from 'lodash';
import React, { useMemo, useRef } from 'react';

import { ActionsMenu } from '~/eds/src/components/ActionsMenu/ActionsMenu';
import { useClickOutside } from '~/eds/src/hooks/useClickOutside';
import { useEscape } from '~/eds/src/hooks/useEscape';
import { Action } from '~/eds/src/types/Action';

import { InteractionPosition } from './types/highlight';

interface Props {
  actions: Action[];
  onCloseMenu?: () => void;
  position?: InteractionPosition;
}

export const InteractionHighlightActionsMenu = ({
  actions: initialActions,
  onCloseMenu = noop,
  position,
}: Props) => {
  const ref = useRef(null);

  useClickOutside(ref, onCloseMenu);
  useEscape(onCloseMenu);

  // rebind the close menu callback onto the action handler
  const actions = useMemo(() => {
    return initialActions.map((action) => ({
      ...action,
      onClick: () => {
        action.onClick?.(action);
        onCloseMenu();
      },
    }));
  }, [initialActions, onCloseMenu]);

  return (
    <div
      ref={ref}
      style={{
        width: 'fit-content',
        ...(position
          ? {
              position: 'absolute',
              left: position.x,
              top: position.y,
            }
          : {}),
      }}
    >
      <ActionsMenu isEmbedded actions={actions} name="highlight-actions-menu" />
    </div>
  );
};
